"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useSortValue = exports.SORT_PARAM_NAME = void 0;
var _presentationQueryState = require("@ori/presentation-query-state");
var _models = require("../../../models");
var _constants = require("../constants");
const SORT_PARAM_NAME = exports.SORT_PARAM_NAME = 'sort';
const useSortValue = ()=>{
    const [orderBy, setOrderBy] = (0, _presentationQueryState.useQueryState)(SORT_PARAM_NAME, (0, _presentationQueryState.parseAsStringEnum)(Object.values(_models.PlpOrderBy)).withDefault(_constants.DEFAULT_ORDER_BY));
    return {
        orderBy,
        setOrderBy
    };
};
exports.useSortValue = useSortValue;
